import { WhatsAppAndCallButtons } from '@/components';
import {
    COMPANY_DETAILS_QUERYResult,
    OPENING_TIMES_FORM_TOP_CONTENT_QUERYResult,
} from 'sanity.types';

export interface OpeningTimesProps {
    openingTimesData: OPENING_TIMES_FORM_TOP_CONTENT_QUERYResult;
    companyDetailsData: COMPANY_DETAILS_QUERYResult;
}

const OpeningTimes = ({
    openingTimesData,
    companyDetailsData,
}: OpeningTimesProps) => {
    const { mondayToFriday, saturday, sunday } =
        openingTimesData[0]?.openingTimes || {};

    return (
        <div className="flex w-full sm:w-1/2 justify-center mx-auto mt-4 flex-wrap text-center">
            <div className="font-bold text-xl w-full justify-center mb-2">
                Opening times
            </div>
            <div className="text-lg w-full mb-1">
                Monday to Friday: {mondayToFriday}
            </div>
            <div className="text-lg w-full mb-1">Saturday: {saturday}</div>
            <div className="text-lg w-full mb-1">Sunday: {sunday}</div>
            <div className="flex-wrap mt-4 flex md:flex-nowrap md:flex-row justify-center md:justify-between">
                <WhatsAppAndCallButtons
                    companyDetails={companyDetailsData[0]?.companyDetails}
                    fullWidth
                />
            </div>
        </div>
    );
};

export default OpeningTimes;
